export const ERROR_CODE = {
  TOKEN_EXPIRED: -10,
  RECORDING_ERROR: 15004,
  OUT_OF_STOCK: 6000,
  CLAIM_COUPON_CODE_OTHER_ERROR: 4001,
  CLAIM_COUPON_CODE_QUOTA_ZERO: 4002,
  CLAIM_COUPON_CODE_EXPIRED: 4003,
  CLAIM_COUPON_CODE_CLAIMED: 4004,
  LIVE_ROOM_CLOSED: 16001,
  // 該房沒有「指定角色」的成員。查房內 IT 名單時沒有 IT 是常態，後端仍回錯誤碼，不該跳 toast
  ROOM_MEMBER_ROLE_NOT_EXIST: 16005,
  INVALID_POSTAL_CODE: -20006,
  USER_DELETED: -4001,
  // 購物車 id 對應不到（不存在，或未登入卻帶會員車 id）。fetchShoppingCartDataThunk 會自動換新車，不該跳 toast
  CART_NOT_FOUND: -5002,
  // Shop 自建登入 v2（feat/login_v2）
  ACCOUNT_NEED_UPGRADE: -20060,
  ACCOUNT_KEY_ALREADY_USED: -20061,
  VERIFY_TICKET_INVALID: -20062,
  // 第三方登入（SDC-2114）
  THIRD_PARTY_BOUND_BY_OTHER_MEMBER: -20063, // 這個第三方帳號已綁定其他會員
  THIRD_PARTY_PROVIDER_ALREADY_BOUND: -20064, // 自己的帳號已綁過同一個 provider
  THIRD_PARTY_AUTH_CANCELLED: -20065, // 使用者在第三方頁按取消
  THIRD_PARTY_AUTH_FAILED: -20066, // 第三方端失敗
  THIRD_PARTY_NEED_PASSWORD: -20067, // E10 開新帳號需要密碼
  THIRD_PARTY_STATE_INVALID: -20068, // state 失效/過期
  VERIFIED_CODE_NOT_MATCH_OR_EXPIRED: -20005,
  LOGIN_FAILED: -10, // 與 TOKEN_EXPIRED 共用同一數值，依呼叫的 API 判斷語意；不可加入 service.js 的 whiteList（會影響既有 TOKEN_EXPIRED 邏輯）
  REGISTER_FAILED: -9,
  INVALID_TOKEN: -6,
  USER_NOT_FOUND: -20000,
  // 單一入口（feat/unified-login-entry）：舊 passport 帳號已被洗進 v2，但沒有密碼可用。
  // login / otp/send(scene=2) / reset-password 都可能回這三碼，一律導去 /migrate-upgrade 走驗證碼重設密碼，
  // 絕對不能顯示「帳號或密碼錯誤」（他打的是舊系統的正確密碼）。
  // ponytail: IDL 尚未 build，數值先照規格文件寫死，swagger 出來後核對
  MIGRATE_UPGRADE_REQUIRED: -20069, // 舊系統只有手機：驗手機 → 設密碼
  MIGRATE_UPGRADE_NEED_NEW_PHONE: -20070, // 舊系統只有信箱：驗信箱 → 補一支新手機 → 設密碼
  MIGRATE_UPGRADE_NEED_VERIFY_OTHER: -20071, // 兩把都有：驗登入時輸入的那把 → 驗另一把 → 設密碼
}

// 上面三個升級碼的集合，登入 / 忘記密碼的 catch 用來判斷要不要轉升級流程
export const MIGRATE_UPGRADE_ERROR_CODES = [
  ERROR_CODE.MIGRATE_UPGRADE_REQUIRED,
  ERROR_CODE.MIGRATE_UPGRADE_NEED_NEW_PHONE,
  ERROR_CODE.MIGRATE_UPGRADE_NEED_VERIFY_OTHER,
]

// Shop 自建登入 v2：service.js 攔截到 ACCOUNT_NEED_UPGRADE 時發出的全域事件，
// 由 App 層的 AccountUpgradeDialog 監聽並跳「帳號升級」Dialog
export const ACCOUNT_NEED_UPGRADE_EVENT = 'accountNeedUpgrade'
